import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Route, UrlSegment } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  private check(cond: string | string[]): boolean {
    const required = Array.isArray(cond) ? cond : [cond];
    const user = this.authService.currentUserValue;
    const ok =
      (required.includes('admin') && user?.isAdmin) ||
      (required.includes('user') && !!user);
    if (!ok) this.router.navigate(['/login']);
    return ok;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      // logged in so return true
      const requiredRole = route.data['role'] as string | undefined;
      if (!requiredRole) {
        return true;
      }

      return this.check(requiredRole)
    }

    // not logged in so redirect to login page with the return url
    // this.authService.logout();
    return false;
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.check(route.data && (route.data['role'] as string));
  }
}
